var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "top-nav flexs jc-sb al-c sticky t-0 l-0 back-f h-70 w-001",
    style: _vm.navStyle
  }, [_c('div', {
    staticClass: "flexs jc-c al-c margin-l-100 margin-r-100 pointer",
    on: {
      "click": _vm.goTop
    }
  }, [_c('img', {
    staticClass: "w-32 h-32 se-c margin-r-10",
    attrs: {
      "src": require("../../assets/images/logo.jpg")
    }
  }), _c('span', {
    staticClass: "fs-30 c-0 f-700"
  }, [_vm._v("AdJM")])]), _c('a', {
    staticClass: "flexs jc-c al-c fs-16 c-f back-2E6AFA w-270 h-70",
    attrs: {
      "href": "https://ad.jumao.net.cn/dist/"
    }
  }, [_vm._v("免费注册/登录")])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };